// Decision logic for "Refine with AI" vs report generation, kept free of React
// so it can be unit-tested. The transcript panel streams a refinement into a
// display-only preview and then waits for the user to Save/Discard it; report
// generation reads the saved transcript, so generating while a refinement is
// pending would silently use the original text (and still spend a credit).

// What a "generate" entry point should do given the refine state.
export const GENERATE_RUN = 'run';         // nothing pending — generate now
export const GENERATE_DIALOG = 'dialog';   // refined text unsaved — ask first
export const GENERATE_BLOCKED = 'blocked'; // stream in flight — button disabled

// What to do right after the user accepts ("Save Changes") a refinement.
export const AFTER_ACCEPT_DONE = 'done';
export const AFTER_ACCEPT_OFFER_REGENERATE = 'offer-regenerate';

// The in-flight stream wins over pending: a stream always starts by clearing
// the pending flag, but the two are separate pieces of state, so the order
// here is what guarantees a button can never open the dialog mid-stream.
export function decideGenerateGate({ isRefiningTranscript = false, isPendingRefinement = false } = {}) {
  if (isRefiningTranscript) return GENERATE_BLOCKED;
  if (isPendingRefinement) return GENERATE_DIALOG;
  return GENERATE_RUN;
}

// True when the history list holds at least one generated report for the
// consultation. `historyItems` is the source of truth here rather than
// `sectionSummaryIdRef`: the ref is only assigned immediately after a
// generation in this session (and is nulled before every regenerate), so it
// is null for a consultation that was opened with reports already saved.
export function hasReportForConsultation(historyItems, consultationId) {
  if (!consultationId || !Array.isArray(historyItems)) return false;
  return historyItems.some(
    (item) => item?.type === 'Document' && item?.originalData?.consultationId === consultationId,
  );
}

// `offerRegenerate` is false when the accept is part of "Save refined &
// generate": the caller is about to generate anyway, so asking would be noise.
export function decideAfterAccept({ hasExistingReport = false, offerRegenerate = true } = {}) {
  return offerRegenerate && hasExistingReport ? AFTER_ACCEPT_OFFER_REGENERATE : AFTER_ACCEPT_DONE;
}
